<template>
  <MenuComponent
    :custom_title="$t('Menu.EventLog')"
    :filtred_count="`${eventList.length}${eventMore ? ' +' : ''}`">
    <template #filter>
      <v-menu
        :close-on-content-click="false"
        :disabled="loading"
        offset-y>
        <template #activator="{ on, value }">
          <div v-on="on">
            <sBadge
              :color="needDot ? 'red' : 'transparent'"
              :content="needDot"
              :dot="true"
              :offset-x="15"
              overlap>
              <sButton
                class="my-auto"
                :color="value ? '#718e8c' : 'var(--black-color)'"
                data-qa="btn-open-filter"
                :disabled="value || loading"
                icon="filter"
                type="text">
                {{ $t('Planning.Filter') }}
              </sButton>
            </sBadge>
          </div>
        </template>
        <div
          class="block-filters">
          <div class="block-filters__item">
            <div class="label-filter">
              {{ $t('Common.Date') }}
            </div>
            <DateRangeDialog
              ref="dateRange"
              data-qa="filter-bar-date-range"
              :search.sync="filterDate"
              @apply="applyDate"/>
            <div class="my-auto ml-2">
              <sButton
                :disabled="!filterDate || !filterDate.length"
                icon="cancel"
                small
                type="text"
                @click="clearDate"/>
            </div>
          </div>
        </div>
      </v-menu>
      <TooltipedBtn
        class="my-auto mr-3"
        data-qa="btn-export-to-excel"
        :disabled="!eventList || !eventList.length"
        icon="excel"
        :loading="loading"
        :text="$t('Tenders.DownloadTendersToExcel')"
        :texted="$vuetify.breakpoint.lgAndUp"
        @click="downloadToExcel"/>
    </template>
    <template #items>
      <div style="width: 100%; max-width: 1024px; margin: 0px auto;">
        <EmptyBlock
          v-if="!loading && eventList.length == 0"
          class="mt-4"
          style="max-width: 1024px; width: 100%; margin: 0 auto;"
          :text="$t('Tenders.NoData')"/>
        <v-data-table
          v-else
          id="eventList"
          calculate-widths
          class="mt-4"
          disable-pagination
          fixed-header
          :headers="headers"
          :hide-default-footer="true"
          item-key="key"
          :items="eventList"
          :no-data-text="$t('Tenders.NoData')"
          style="max-width: 1024px; width: 100%; margin: 0 auto;">
          <template #[`item.type`]="{ item }">
            {{ types[item.type] }}
          </template>
          <template #[`item.org`]="{ item }">
            {{ item.user.orgNme }}
            <div class="opacity-5 font-size-12">
              {{ item.user.okpo }}
            </div>
            <div
              v-if="item.tariffCost"
              class="opacity-5 font-size-12">
              {{ $t('Common.tariff') }}: {{ $n(item.tariffCost) }}
            </div>
          </template>
          <template #[`item.user`]="{ item }">
            {{ item.user.fio }}
            <div class="opacity-5 font-size-12">
              {{ item.user.email }}
            </div>
            <div class="opacity-5 font-size-12">
              {{ item.user.tel }}
            </div>
          </template>
          <template #[`item.date`]="{ item }">
            {{ $d(new Date(item.date), "shortDate") }} {{ $d(new Date(item.date), "time") }}
          </template>
        </v-data-table>
      </div>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="getEvents"
        :active="eventMore"
        call-on-mount
        class="mt-3"
        :loading="loading"/>
    </template>
  </MenuComponent>
</template>
<script>

import { debounce } from 'toolkit/utils/util'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'

import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()

import axios from 'axios'
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

export default {
  name: 'EventsStat',
  data() {
    return {
      eventMore: true,
      loading: true,
      take: 15,
      types: {
        'REDIRECT_TO_YK_MARKET': 'YKMarket',
        'REDIRECT_CREATE_TENDER': 'Посилання на створення тендеру',
        'REDIRECT_EDIT_TENDER': 'Посилання на редагування тендеру',
      },
      eventList: [],
      headers: [
        {text: this.$t('Common.Event'), value: 'type', width: '200px', disableFilter: true, sortable: true, order: 1},
        {text: this.$t('Tenders.Company'), value: 'org', sortable: false, order: 2},
        {text: this.$t('Common.User'), value: 'user', sortable: false, order: 4},
        {text: this.$t('Common.Date'), value: 'date', width: '145px', sortable: true, order: 5},
      ],
      filter: {
        date: {},
        types: []
      },
      oldFilter: null,
    }
  },
  methods: {
    clearDate() {
      this.filterDate = null
      this.$refs.dateRange.dateFrom = ''
      this.$refs.dateRange.dateTo = ''
      this.applyDate()
    },
    applyDate() {
      if (JSON.stringify(this.oldFilter) !== JSON.stringify(this.filter)) {
        this.eventList = []
        this.eventMore = true
        this.getEvents()
      }
    },
    async downloadToExcel() {
      this.loading = true
      const url = `${window.config.GrapgQlUrl}/files/generateUserActionsEventLog`
      const headers = await files_api.getHeaders()

      headers['Content-Type'] = 'application/json'
      await axios.post(url,
        this.filtersProps,
        {
          headers,
          responseType: 'blob'
        }
      ).then((response) => {
        var { extension } = require('mime-types')
        let url = URL.createObjectURL(response.data)
        let a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', `${this.$t('Menu.EventLog')}.${extension(response.data.type)}`)
        a.click()
      }).finally(() => {
        this.loading = false
      })
    },
    getEvents: debounce(function () {
      if (!this.eventMore) {
        return
      }
      this.loading = false
      const filter = {
        ...this.filtersProps,
        ...{
          take: this.take,
          skip: this.eventList?.length,
        }
      }

      api.getEvents(filter)
        .then((result) => {
          if (result?.length) {
            this.eventMore = result.length >= this.take
            this.eventList = []
              .concat(this.eventList)
              .concat(result || [])
              .sort((a,b) => new Date(b.date) - new Date(a.date)
              || a.type - b.type
              || a.user.orgNme?.localeCompare(b.user.orgNme) || a.user.fio?.localeCompare(b.user.fio))
          } else {
            this.eventMore = false
          }
        })
        .finally(() => {
          this.oldFilter = this.$_.cloneDeep(this.filter)
          this.loading = false
        })
    }, 250),
  },
  computed: {
    filtersProps() {
      const filter = {}
      if (this.filter.types?.length) {
        filter.types = this.filter.types
      }
      if (this.filter.date && (this.filter.date.from || this.filter.date.to)) {
        filter.date = {}
        if (this.filter.date.from) {
          filter.date.from = this.filter.date.from
        }
        if (this.filter.date.to) {
          filter.date.to = this.filter.date.to
        }
      }
      return filter
    },
    filterDate: {
      get() {
        const result = [
          this.filter.date.from || '',
          this.filter.date.to || ''
        ]
        return result
      },
      set(newValue) {
        if (!newValue) {
          this.$set(this.filter, 'date', {})
        } else {
          this.$set(this.filter.date, 'from', newValue[0])
          this.$set(this.filter.date, 'to', newValue[1])
        }
      }
    },
    needDot() {
      return this.filter.date.from || this.filter.date.to
    }
  },
  components: {
    EmptyBlock,
    TooltipedBtn,
    MenuComponent,
    InfinityUpdater,
    DateRangeDialog
  },
  created() {
    this.getEvents()
  },
}
</script>
<style scoped lang="scss">
.block-filters {
  display: block;
  border-radius: 4px;
  border: 2px solid var(--white-color);
  background: var(--v-main__light_green-base);
  padding: 24px;
  &__item {
    display: grid;
    grid-template: minmax(40px, auto)/50px 1fr 40px;
  }
}
</style>
